"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
0 && (module.exports = {
    StackScreenBackButton: null,
    StackScreenTitle: null,
    appendStackScreenBackButtonPropsToOptions: null,
    appendStackScreenTitlePropsToOptions: null
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get StackScreenBackButton () {
        return _StackScreenBackButton.StackScreenBackButton;
    },
    get StackScreenTitle () {
        return _StackScreenTitle.StackScreenTitle;
    },
    get appendStackScreenBackButtonPropsToOptions () {
        return _StackScreenBackButton.appendStackScreenBackButtonPropsToOptions;
    },
    get appendStackScreenTitlePropsToOptions () {
        return _StackScreenTitle.appendStackScreenTitlePropsToOptions;
    }
});
const _StackScreenTitle = require("./StackScreenTitle");
const _StackScreenBackButton = require("./StackScreenBackButton");

//# sourceMappingURL=index.js.map
